import React, { Suspense } from "react";

import EnvironmentProvider from "@/api/common/contexts/EnvironmentProvider"
const CartItemsCounter = React.lazy(() => import("@/widgets/cart-items-count"));

export const CartItemsCounterWrapper: React.FC = () => {
  return <EnvironmentProvider environment={import.meta.env.VITE_ENVIRONMENT}>
   <Suspense fallback={<div></div>}>
        <CartItemsCounter />
      </Suspense>
  </EnvironmentProvider>
}